import { ProjectId } from "@taskin-code/contracts";
import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useFocusedProject } from "~/focusMode";
import { useStore } from "~/store";

function FocusedProjectRouteLayout() {
  const navigate = useNavigate();
  const { projectId: projectIdParam } = Route.useParams();
  const projectId = ProjectId.makeUnsafe(projectIdParam);
  const threadsHydrated = useStore((state) => state.threadsHydrated);
  const project = useStore(
    (state) => state.projects.find((entry) => entry.id === projectId) ?? null,
  );
  const { setFocusedProject } = useFocusedProject();

  useEffect(() => {
    setFocusedProject(projectId);
  }, [projectId, setFocusedProject]);

  useEffect(() => {
    if (!threadsHydrated || project) return;
    setFocusedProject(null);
    void navigate({ to: "/", replace: true });
  }, [navigate, project, setFocusedProject, threadsHydrated]);

  // The initial empty store is not evidence that the URL is invalid. Wait for
  // the orchestration snapshot before redirecting a project route away.
  return <Outlet />;
}

export const Route = createFileRoute("/_chat/projects/$projectId")({
  component: FocusedProjectRouteLayout,
});
